<template>
  <div class="WSettings contentBack">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统设置 </el-breadcrumb-item>
      <el-breadcrumb-item class="breadSelected">预警设置 </el-breadcrumb-item>
    </el-breadcrumb>
    <h2 class="titleH2">专利预警设置</h2>

    <!-- <div class="Wcontent1">
      <span>预警类型：</span>
      <span>提醒预警：</span>
      <span>终止预警：</span>
      专利预警设置：<span style="color: #737373">届满前</span>
      <span style="font-size: 16px; color: #1471d5; font-weight: bold">
        &lt;= </span
      ><input type="text" v-model="ptDay" />天 进行预警
    </div> -->
    <div class="bb cc">
      <span>预警类型：</span>
      <el-checkbox
        v-model="checkAll"
        @change="handleCheckAllChange"
        style="margin-right: 23px; margin-left: 20px"
        >全部</el-checkbox
      >
      <el-checkbox-group
        v-model="chooseType"
        @change="handleCheckedCompanyChange"
      >
        <el-checkbox label="1" name="apt">发明专利</el-checkbox>
        <el-checkbox label="2" name="apt">实用新型</el-checkbox>
        <el-checkbox label="3" name="apt">外观设计</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="bb">
      <span>提醒预警：</span>
      <span class="dd">届满前</span>
      <span style="font-size: 16px; color: #1471d5; font-weight: bold">
        &lt;= </span
      ><input type="text" v-model="ptDay" /><span class="ee">天 进行预警</span>
    </div>
    <div class="bb">
      <span>终止预警：</span>
      <span class="dd">届满后</span>
      <span style="font-size: 16px; color: #1471d5; font-weight: bold">
        &lt;= </span
      ><input type="text" v-model="ptDayEnd" /><span class="ee"
        >天 结束预警</span
      >
    </div>
    <h3 class="titleH2">商标预警设置</h3>
    <div class="bb">
      <span>提醒预警：</span>
      <span class="dd">专用权截止日前</span>
      <span style="font-size: 16px; color: #1471d5; font-weight: bold">
        &lt;= </span
      ><input type="text" v-model="tmDay" /><span class="ee">天 进行预警</span>
    </div>

    <el-button type="primary" @click="warningReset">保存</el-button>
  </div>
</template>
<script>
import { Message } from "element-ui";

export default {
  data() {
    return {
      ptDay: "",
      tmDay: "",
      ptDayEnd: "",
      chooseType: ["1"],
      aa: ["1", "2", "3"],
      checkAll: false,
    };
  },
  methods: {
    handleCheckedCompanyChange(value) {
      this.checkAll = value.length == this.aa.length;
    },
    handleCheckAllChange(value) {
      value ? (this.chooseType = this.aa) : (this.chooseType = []);
    },
    warningReset() {
      if (
        this.ptDay == localStorage.getItem("ptDay") &&
        this.tmDay == localStorage.getItem("tmDay") &&
        this.ptDayEnd == localStorage.getItem("ptDayEnd") &&
        this.chooseType == JSON.parse(localStorage.getItem("ptType"))
      ) {
        Message({ message: "未做任何修改" });
      } else {
        let data = {
          uid: localStorage.getItem("uid"),
          tmDay: this.tmDay,
          ptDay: this.ptDay,
          ptDayEnd: this.ptDayEnd,
          ptType: this.chooseType.join(";"),
        };
        var that = this;
        this.$post("/user/alert", data).then((res) => {
          if (data.ptType === "") {
            this.$message({
              type: "warning",
              message: "请选择预警类型",
            });
            return;
          }
          // console.log(res);
          if (res.status == 200) {
            localStorage.setItem("ptDay", that.ptDay);
            localStorage.setItem("tmDay", that.tmDay);
            localStorage.setItem("ptDayEnd", that.ptDayEnd);
            localStorage.setItem("ptType", JSON.stringify(that.chooseType));
            that.tmDay = localStorage.getItem("tmDay");
            that.ptDay = localStorage.getItem("ptDay");
            that.ptDayEnd = localStorage.getItem("ptDayEnd");
            that.chooseType = JSON.parse(localStorage.getItem("ptType"));

            Message({
              message: res.msg,
              type: "success",
            });
          } else {
            Message({
              message: res.msg,
            });
          }
        });
      }
    },
  },
  mounted() {
    this.ptDay = localStorage.getItem("ptDay");
    this.tmDay = localStorage.getItem("tmDay");
    this.ptDayEnd = localStorage.getItem("ptDayEnd");
    this.chooseType = JSON.parse(localStorage.getItem("ptType"));
    if (this.chooseType.length == this.aa.length) {
      this.checkAll = true;
    }
  },
};
</script>
<style>
.WSettings input {
  padding: 8px;
  width: 73px;
  height: 19px;
  border: 1px solid #dbdbdb;
  margin-right: 10px;
  outline: 0;
  margin-top: -5px;
  margin-left: 5px;
}
.WSettings .el-button {
  padding: 0;
  width: 94px;
  height: 30px;
  margin-left: 24px;
  margin-top: 46px;
  background: #1471d5;
  border-radius: 3px;
  font-size: 16px;
}
.titleh3 {
  margin-top: 44px;
  margin-bottom: 23px;
  margin-left: 24px;
  font-size: 14px;
  color: #333;
}
.bb {
  display: flex;
  margin-left: 24px;
  color: #737373;
  font-size: 14px;
  margin-bottom: 15px;
}
.cc {
  margin-bottom: 24px;
}
.dd {
  margin-left: 24px;
  margin-right: 12px;
}
.ee {
  color: #000;
}
.titleH2 {
  margin-bottom: 30px;
}
</style>